<div class="contacts-management">
  <div class="contacts-management-header">
    <h5>{{ 'fgbcl.contacts.management.title' | translate }}</h5>
    <div class="action-wrapper">
      <button class="btn btn-danger" (click)="addNewContact()">
        <i class="material-icons">person_add</i>{{ 'fgbcl.contacts.management.add.contact.button' | translate }}
      </button>
    </div>
  </div>

  <ng-container *ngIf="addressBook$ | async as contacts">
    @if (contacts?.length > 0) {
      <div class="contacts-management-table">
        <!-- Desktop view -->
        <div class="d-none d-lg-flex">
          <table class="table">
            <thead class="contacts-management-table-header">
              <tr>
                <th>{{ 'fgbcl.contacts.management.fullname.label' | translate }}</th>
                <th>{{ 'fgbcl.contacts.management.email.label' | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let contact of contacts">
                <td class="col-contact">{{ contact.FullName }}</td>
                <td class="col-email">{{ contact.EmailAddress }}</td>
                <td class="col-action">
                  <a (click)="editContact(contact)">{{ 'fgbcl.contacts.management.edit.button' | translate }}</a>
                  <a class="text-danger" (click)="deleteContact(contact)">{{
                    'fgbcl.contacts.management.remove.button' | translate
                  }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Mobile view -->
        <div class="d-flex d-lg-none">
          <div class="contacts-management-mobile-container">
            <div class="contacts-management-list">
              <div class="contacts-management-list-item" *ngFor="let contact of contacts">
                <div class="contacts-management-info">
                  <div class="info-label">{{ 'fgbcl.contacts.management.fullname.label' | translate }}</div>
                  <div class="info-value">{{ contact.FullName }}</div>
                </div>
                <div class="contacts-management-info">
                  <div class="info-label">{{ 'fgbcl.contacts.management.email.label' | translate }}</div>
                  <div class="info-value">{{ contact.EmailAddress }}</div>
                </div>
                <div class="action-wrapper">
                  <a (click)="editContact(contact)">{{ 'fgbcl.contacts.management.edit.button' | translate }}</a>
                  <a class="text-danger" (click)="deleteContact(contact)">{{
                    'fgbcl.contacts.management.remove.button' | translate
                  }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="contacts-management-no-data">{{ 'fgbcl.contacts.management.no.data' | translate }}</div>
    }
  </ng-container>
</div>
